import PropTypes from "prop-types";
import React, { Component } from "react";
import PackageItem from "./PackageItem";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class PackageList extends Component {
  state = {
    basketList: [],
    familyRef: React.createRef()
  };

  isSelectable(subjectPackage, basket) {
    const clashInBasket = basket.filter(packageInBasket =>
        packageInBasket.packagesConflicting.includes(subjectPackage.productID)
    );
    // if the length of the returned array is 0 then no matches were found
    // if this is the case then the item can be added to the basket
    return clashInBasket.length <= 0;
  }

  /**
   * if the item is in the basket then return true if not return false
   */
  isInBasket = (subjectPackage, basket) => {
    const checkBasket = basket.find(
      packageInBasket => packageInBasket.packageID === subjectPackage.packageID
    );

    return checkBasket ? true : false;
  };

  /**
   * updatePackage -
   *  Add, Remove and Update items in the basket.
   * @param {number} packageID - Unique ID of the Package
   * @param {number} packageQuantity - Number of Packages
   * @return {} - returns nothing
   */
  updatePackage = (packageID, packageQuantity = 1) => {
    let packageItem = this.getPackage(packageID);
    packageItem.packageQuantity = packageQuantity;

    const packageNotInBasket = !this.isInBasket(packageItem, this.props.basket);

    if (packageItem.canOrderMultiple) {
      if (packageItem.packageQuantity === 0) {
        this.props.updateBasket(packageItem);
        this.props.removePackageFromBasket(packageItem);
      } else if (packageNotInBasket) {
        this.props.addToBasket(packageItem);
      } else {
        this.props.updateBasket(packageItem);
        return;
      }
    } else {
      if (packageNotInBasket) {
        this.props.addToBasket(packageItem);
      } else {
        this.props.removePackageFromBasket(packageItem);
      }
    }
    return;
  };

  getPackage = packageID =>
    this.props.packages.find(
      currentPackage => currentPackage.packageID === packageID
    );

  // the productID looks like this: "PK_EP_56" we want to turn this string
  // into an array to look like this [PK,EP,56] we now want the 2nd value
  // in the array, this is the brand!
  getPackageBrand = productID => productID.split("_")[1];

  render() {
    const { packages, removePackageFromBasket, basket, site } = this.props;
    return (
      <Container fluid className="package__container" ref={this.state.familyRef}>
        <Row>
          {packages.map(subjectPackage => (
          <Col md={subjectPackage.size} xs={12} key={subjectPackage.packageID}>
            <PackageItem
              updatePackage={this.updatePackage}
              removePackageFromBasket={removePackageFromBasket}
              selectable={this.isSelectable(subjectPackage, basket)}
              inBasket={this.isInBasket(subjectPackage, basket)}
              size={subjectPackage.size}
              price={Number(subjectPackage.price)}
              name={subjectPackage.Name}
              packageID={subjectPackage.packageID}
              description={subjectPackage.Description}
              productNameList={subjectPackage.productNameList}
              packageBrand={this.getPackageBrand(subjectPackage.productID)}
              canOrderMultiple={subjectPackage.canOrderMultiple}
              packageClass={subjectPackage.cssClass}
              packageQuantity={subjectPackage.packageQuantity}
              site={site}
              freeMaths={this.props.freeMaths}
              familyID={subjectPackage.familyID}
              width={this.props.width}
            />
          </Col>
          ))}
        </Row>
      </Container>
    );
  }
}

PackageList.propTypes = {
  packages: PropTypes.array,
  removePackageFromBasket: PropTypes.func,
  basket: PropTypes.array,
  addToBasket: PropTypes.func,
  site: PropTypes.object
};

export default PackageList;
